<template>
  <div id="table">
    <table>
      <thead>
        <tr>
          <th v-for="(header, i) in headers" :key="`${i}_headers`" class="text-left">
            {{ header.text }}
          </th>
        </tr>
      </thead>

      <tbody>
        <template v-if="loading">
          <tr>
            <td :colspan="headers.length" style="height: 5px">
              <v-progress-linear
                indeterminate
                color="red"
                height="4px"
              ></v-progress-linear>
            </td>
          </tr>
          <tr>
            <td :colspan="headers.length" class="text-center py-2">
              Carregando produtos... aguarde.
            </td>
          </tr>
        </template>

        <template v-else-if="itens.length === 0">
          <tr>
            <td :colspan="headers.length" class="text-center py-2">
              Não há dados disponíveis
            </td>
          </tr>
        </template>

        <tr
          v-for="(item, i) in itens"
          :key="`${i}_itens`"
          :style="pintaProdutoPesquisado(item)"
        >
          <td v-for="(header, index) in headers" :key="`${index}_header`" class="pl-1">
            <template v-if="header.formatar">{{ Helpers.formatarValor(item[header.value]) }}</template>
            <template v-else>{{ item[header.value] }}</template>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import DrpAPI from "../../../../api/drp"

export default {
  name: "tabelaDeProdutosDoPedido",
  props: {
    pedido: {
      type: Object,
      required: false
    },
    pesquisa: {
      type: String,
      required: false
    }
  },
  data: () => ({
    headers: [
      { text: 'Filial Origem', value: 'filial_origem'},
      { text: 'Filial Destino', value: 'filial_destino'},
      { text: 'Id Produto', value: 'idproduto'},
      { text: 'Descricao Produto', value: 'descricao_produto'},
      { text: 'Qtde. Pedido', value: 'qtde_pedido', formatar: true},
      { text: 'Cód. Produto', value: 'cod_produto'},
      { text: 'Id Fornecedor', value: 'idfornecedor'}
    ],
    itens: [],
    loading: false
  }),
  created() {
    this.buscarProdutosDoPedido(this.pedido.idpedido)
  },
  methods: {
    pintaProdutoPesquisado (item) {
      if (!this.pesquisa || this.pesquisa.trim().length === 0) {
        return ''
      }

      const str = (item.idproduto.concat(' - ', item.descricao_produto))

      return str.indexOf(this.pesquisa.toUpperCase().trim()) > -1
        ? 'background: #F0E68C'
        : ''
    },
    buscarProdutosDoPedido (pedido) {
      this.loading = true
      const headers = this.Helpers.iniciarRequisicao()
      const params = {pedido}

      DrpAPI.getPedido(headers, params)
        .then(response => {
          const {token, pedido} = response.data
          localStorage.setItem("token", token)
          this.itens = pedido
          this.loading = false
        })
        .catch(() => {
          this.loading = false
          this.Helpers.logout()
        })
    }
  }
}
</script>

<style scoped>
#table {
  height: 250px;
  overflow-y: auto;
  background: white;
}
#table table {
  width: 100%;
  border-collapse: collapse;
}
#table table thead tr th {
  background: rgba(0,0,0,.05);
}
#table table tr td {
  height: 25px;
  border-bottom: 1px solid rgba(0,0,0,.08);
}
</style>
